import { render, staticRenderFns } from "./WantReceives.vue?vue&type=template&id=0189091c&"
import script from "./WantReceives.vue?vue&type=script&lang=js&"
export * from "./WantReceives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports